import { ContentMarketingImageData } from '../../../../shared/types/contentMarketing';
import * as React from 'react';

const ImageWithFocus = ({
    imageData,
    alt,
    isMultipleAds,
    hasImageRadius,
}: {
    imageData: ContentMarketingImageData;
    alt: string;
    isMultipleAds: boolean;
    hasImageRadius?: boolean;
}) => {
    function getPercentage(n: number, size: number) {
        return (n / size) * 100;
    }

    const y = getPercentage(imageData.aoi.focus.y, imageData.height);
    const x = getPercentage(imageData.aoi.focus.x, imageData.width);

    function renderImage() {
        return (
            <img
                alt={alt}
                src={imageData.url}
                className={`h-full w-full object-cover ${
                    hasImageRadius ? 'rounded-8' : ''
                }`}
                style={{
                    objectPosition: `${x}% ${y}%`,
                }}
            />
        );
    }

    if (isMultipleAds) {
        return <div className={'h-144'}>{renderImage()}</div>;
    } else return renderImage();
};

export default ImageWithFocus;
